module.exports = __webpack_public_path__ + "img/logo-fulfillment.f41eb7b7.svg";